document.addEventListener( "DOMContentLoaded" , () => {
  const uploaders = document.querySelectorAll( '[data-logo-uploader]' );

  for ( let i = 0; i < uploaders.length; i++ ) {
    const uploader = uploaders[ i ];

    if ( uploader.getAttribute( 'data-logo-uploader-initialized' ) === 'true' ) {
      continue;
    }

    uploader.setAttribute( 'data-logo-uploader-initialized', 'true' );

    const context = uploader.querySelector( '[data-logo-upload-context]' );
    const uploadInput = uploader.querySelector( '[data-logo-upload-url]' );
    const preview = uploader.querySelector( '[data-logo-upload-preview]' );
    const previewImage = uploader.querySelector( '[data-logo-upload-preview-image]' );
    const fileName = uploader.querySelector( '[data-logo-upload-filename]' );
    const manageButton = uploader.querySelector( '[data-logo-upload-manage]' );

    if ( !context || !uploadInput || !preview || !previewImage || !fileName || !manageButton ) {
      continue;
    }

    const api = context.getAPI();

    function updateDisplay( uploadCollection ) {
      const successfulEntries = uploadCollection?.successEntries || [];

      if ( successfulEntries.length <= 0 ) {
        uploadInput.value = '';
        previewImage.innerHTML = '';
        fileName.textContent = '';
        preview.classList.add( 'hidden' );
        return;
      }

      const uploadedFile = successfulEntries[ 0 ];

      if ( !uploadedFile.cdnUrl ) {
        return;
      }

      uploadInput.value = uploadedFile.cdnUrl;
      fileName.textContent = uploadedFile.name || uploadedFile.fileName || 'Uploaded file';

      previewImage.innerHTML = '';

      const extension = fileName.textContent.split( '.' ).pop().toLowerCase();
      const canPreview = [ 'png', 'jpg', 'jpeg', 'svg' ].includes( extension );

      if ( canPreview ) {
        const image = document.createElement( 'img' );
        image.src = uploadedFile.cdnUrl;
        image.alt = fileName.textContent;

        previewImage.appendChild( image );
      }

      preview.classList.remove( 'hidden' );
    }

    context.addEventListener( 'change', function( event ) {
      updateDisplay( event.detail );
    });

    context.addEventListener( 'modal-close', function() {
      // Sync display with Uploadcare's current state here.
    });

    manageButton.addEventListener( 'click', function() {
      api.setCurrentActivity( 'upload-list' );
      api.setModalState( true );
    });
  }
});